































































































































































import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { ICompany } from '@resclick/data-access';
import { date } from 'quasar';
import { Component, Mixins } from 'vue-property-decorator';
import addToDate = date.addToDate;
import { Getter } from 'vuex-class';
import { i18n } from '@/i18n';

@Component
export default class TabGeneral extends Mixins(ModalTabMixin) {
  @Getter('user/currentCompany') currentCompany!: string;

  form!: CrsForm<'companies', 'create' | 'update'>;

  get addressValidators() {
    return {
      country: {
        hasError: this.form.hasError('address.country'),
        message: this.form.getError('address.country'),
      },
      province: {
        hasError: this.form.hasError('address.province'),
        message: this.form.getError('address.province'),
      },
      district: {
        hasError: this.form.hasError('address.district'),
        message: this.form.getError('address.district'),
      },
    };
  }

  get companyTypeOptions() {
    // TODO Need implementation
    return [
      { label: 'Buyer', value: 'BUYER' },
      { label: 'Supplier', value: 'SUPPLIER' },
    ];
  }

  get brandingTypeOptions() {
    // TODO Need implementation
    return [
      { label: i18n.t('GENERAL.COMPANY'), value: 'COMPANY' },
      { label: i18n.t('GENERAL.PROPERTY'), value: 'PROPERTY' },
    ];
  }

  get parentCompanyQuery() {
    const filter: { [key: string]: Record<string, unknown> } = {};
    if (this.id) filter.id = { $ne: this.id };
    return { filter };
  }

  getForm() {
    return compass.do('companies', 'findOne', {
      params: { companyId: this.id as string },
    });
  }

  created() {
    this.form = this.$crsForm('companies', this.mode, {
      isActive: false,
      name: '',
      title: '',
      contactName: '',
      email: '',
      phoneNumber: '',
      faxNumber: '',
      address: {
        line1: '',
        line2: '',
        postalCode: '',
      },
      parent: '',
      isBuyer: false,
      isSupplier: false,
      subscriptions: [
        {
          name: 'CRS',
          startDate: new Date(),
          endDate: addToDate(new Date(), { year: 100 }),
        },
      ],
      brandingType: 'COMPANY',
      canSeePrices: false,
    });

    this.$once('update-data', (data: ICompany) => {
      this.form = this.$crsForm('companies', 'update', data);
    });
  }
}
